import { getPrismic } from "../utils/get-prismic";
import { Box, Flex, Heading, Text } from "rebass";
import { maxWidth, height } from "styled-system";
import styled from "styled-components";
import * as moment from "moment";
import { Banner } from "../components/banner";
import { DynamicNextLink } from "../components/dynamic-next-link";
import { ModuleGrid } from "../components/module-grid";
import { ResponsiveIframe } from "../components/responsive-iframe";

const Impact = ({ pageData, impacts }) => {
  const {
    title,
    description,
    hero_video,
    hero_title,
    hero_description
  } = pageData.data;

  const mappedImpacts = impacts.map(impact => {
    const data = impact.data;
    return {
      image: data.image,
      title: data.title,
      details: moment(impact.first_publication_date).format("dddd, MMMM D, Y"),
      description: data.excerpt,
      link: {
        internal: true,
        href: `/impact-detail?uid=${impact.uid}`,
        as: `/impact/${impact.uid}`
      }
    };
  });

  return (
    <div>
      <Banner title={title} description={description} />
      <Box bg="white" mt={[4, 4, 4, 5]} px={[3, 3, 3, 4]} pb={[0, 3, 4]}>
        <Container maxWidth={3} mx="auto">
          <Box mt={[-35, -35, -65]} width={1}>
            <ResponsiveIframe iframe={hero_video.html} />
          </Box>
        </Container>
        <Container maxWidth={2} mx="auto" flexWrap="wrap">
          <Box width={[1, 1, 4 / 10]} pr={[0, 0, 4]} mt={4}>
            <S_Heading
              as="h2"
              color="blue.2"
              fontSize={[4, 5, 40]}
              fontFamily="medium"
              letterSpacing={[4, 1]}
              lineHeight={1}
            >
              {hero_title}
            </S_Heading>
          </Box>
          <Box width={[1, 1, 6 / 10]} color="black" mt={[3, 4]}>
            <Box>
              <Text fontSize={[2, 2, 2, 3]} lineHeight={1.5555555556}>
                {hero_description}
              </Text>
            </Box>
          </Box>
        </Container>
      </Box>

      <Box px={[3, 3, 3, 4]} py={[4, 4, 4, 6]} bg="white">
        <ModuleGrid items={mappedImpacts} />
      </Box>
    </div>
  );
};

const Container = styled(Flex)`
  ${maxWidth}
`;

const ImageWrap = styled(Box)`
  ${height}

  img {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
  }
`;

const S_Heading = styled(Heading)`
  text-transform: uppercase;
`;

const S_DynamicNextLink = styled(DynamicNextLink)`
  &.underline a,
  a:hover {
    text-decoration: underline;
  }
`;

Impact.getInitialProps = async context => {
  const pageData = await getPrismic({
    fragment: "my.impact_listing.uid",
    value: "impact",
    context
  });
  const impacts = await getPrismic({
    fragment: "document.type",
    value: "impact",
    context,
    options: {
      orderings: "[document.first_publication_date desc]"
    },
    multiple: true
  });
  return { pageData, impacts };
};

export default Impact;
